export default __webpack_public_path__ + "static/media/phone.8cbf6e64.jpg";